import { DOWNLOAD_STATUS } from "../../constants/constants";
import { visibilityDownloaderProgress } from "../../utils/downloading";
import { getArrayIndex } from "../../utils/lodash";
import {
	SET_VISIBILITY,
	SET_FILE_DOWNLOADING,
	SET_DOWNLOADING_VISIBILITY
} from "./actionTypes";

const initialState = {
	requestCount: 0,
	showDownloadProgress: true,
	downloadingFiles: []
};

let dTimeout = null;


const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_VISIBILITY: {
			let count = state.requestCount;
			if (action.payload == true) {
				count++;
			} else {
				count--;
			}
			if (count < 0) {
				count = 0;
			}
			return {
				...state,
				requestCount: count
			};
		}
		case SET_FILE_DOWNLOADING:{
			// const dFileList = removeCompletedDownload(state.downloadingFiles);
			const dFileList = state.downloadingFiles;

			if (
				action.payload.details.status === DOWNLOAD_STATUS.completed ||
				action.payload.details.status === DOWNLOAD_STATUS.failed
			) {
				const index = getArrayIndex(dFileList, {
					dKey: action.payload.details.dKey
				});
				const inProgressList = dFileList.filter(
					x => x.status === DOWNLOAD_STATUS.downloading
				);

				if (inProgressList.length === 1) {
					dTimeout = setTimeout(() => visibilityDownloaderProgress(), 15000);
				}

				dFileList[index].status = action.payload.details.status;
				return {
					...state,
					downloadingFiles: [...dFileList]
				};
			}
			clearTimeout(dTimeout);
			return {
				...state,
				showDownloadProgress: true,
				downloadingFiles: [action.payload.details, ...dFileList]
			};
		}
		case SET_DOWNLOADING_VISIBILITY:
			return {
				...state,
				showDownloadProgress: action.payload
			};
		default:
			return state;
	}
};

export default reducer;
